import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAnalytics, isSupported } from 'firebase/analytics';

// Your Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAw7_9dFroI5iX5Q2jGFQFlHCtFPl6NIZo",
  authDomain: "website-5f580.firebaseapp.com",
  databaseURL: "https://website-5f580-default-rtdb.firebaseio.com",
  projectId: "website-5f580",
  storageBucket: "website-5f580.firebasestorage.app",
  messagingSenderId: "35928169975",
  appId: "1:35928169975:web:0c2e01ba3a3ea542d162f2",
  measurementId: "G-ZP4TCENZ4L"
};

// SMTP Configuration
export const smtpConfig = {
  // appPassword: "cuza mhdv mfrt yixn"

  appPassword: "mqry sdgi vhac upjk"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app);

// Initialize Firebase Storage and get a reference to the service
export const storage = getStorage(app);

// Initialize Firebase Analytics (only in browser environment)
let analytics = null;
if (typeof window !== 'undefined') {
  try {
    isSupported().then((supported) => {
      if (supported) {
        analytics = getAnalytics(app);
        console.log('Firebase Analytics initialized');
      }
    }).catch((error) => {
      console.error('Analytics not supported:', error);
    });
  } catch (error) {
    console.error('Error initializing Analytics:', error);
  }
}
export { analytics };

export default app;
